import(/* webpackMode: "eager" */ "/app/app/mafia/page.tsx");
